import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MultiSelectComponent, MultiSelectModule } from '@progress/kendo-angular-dropdowns';
import { ColorService } from 'src/app/core/services/colors/color.service';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { ChecklistsQuestion } from 'src/app/features/bizzmine/form/components/controls/execute-checklist-control/interfaces/checklists-question.interface';
import { ToggleArrowComponent } from 'src/app/shared/components/ui/toggle-arrow/toggle-arrow.component';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';
import { ResultClassValue } from 'src/models/ts/result-class-value';

@Component({
  selector: 'bizz-singlechoice-control',
  standalone: true,
  imports: [MultiSelectModule, ToggleArrowComponent,
    CommonModule, TranslatePipe
  ],
  templateUrl: './singlechoice-control.component.html',
  styleUrl: './singlechoice-control.component.scss'
})
export class SinglechoiceControlComponent implements OnInit {
  @Input() public isMobileView: boolean = false;
  @Input({ required: true }) public question: ChecklistsQuestion;
  public isLocked = input.required<boolean>();
  @Output() public questionChange = new EventEmitter<ChecklistsQuestion>;
  @Output() public resetButtonsOptions = new EventEmitter<boolean>();
  public selectedColor: ResultClassValue[] = [];
  @Input() public isNaNc: boolean = false;
  @Input() public isDarkTheme: boolean = false;
  @ViewChild('multiSelectInput') public multiSelectInput: MultiSelectComponent;

  public get answerIsNull(): boolean {
    return this.question.UserAnswer.Value == null && this.question.UserAnswer.Answer == null;
  }

  public constructor(public colorService: ColorService, public themeService: ThemeService) {
  }

  public ngOnInit(): void {
    if (this.question.UserAnswer.ResultClassValueID) {
      const selectedColor = this.question.ResultClass.ResultClassValues.Values.find((value: ResultClassValue) => value.ID === this.question.UserAnswer.ResultClassValueID) as ResultClassValue;
      this.selectedColor = [selectedColor];
    }
  }

  public singleChoiceSelection(answer: ResultClassValue[] | any): void {
    const value = answer[answer.length - 1];
    if (value.ID === this.question.UserAnswer.ResultClassValueID) {
      return;
    }
    this.selectedColor = [value];
    if (this.answerIsNull) {
      this.question.UserAnswer.Answer = value;
      this.question.UserAnswer.ResultClassValueID = value.ID;
    } else {
      this.resetButtonsOptions.emit(true);
      this.question.UserAnswer.Answer = value;
      this.question.UserAnswer.ResultClassValueID = value.ID;
      this.question.UserAnswer.Value = null;
    }
    this.questionChange.emit(this.question);
  }


}
